import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { EditingMode } from '../../models/editingMode';
import { Destinatario } from "../../../asistente-en-linea/models/Destinatario";
import { DestinatariosService } from '../destinatarios/destinatarios.service';
import { Role } from "../../models/role";
import { DeleteDestinatarioDialogComponent } from '../destinatarios/dialog/delete/delete-destinatario-dialog.component';
import { AuthService } from '../../auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { DestinatarioTipo } from '../models/destinatario-tipo';
import { ImportDestinatarioValidacionDialogComponent } from '../menu/dialog/importdestval/import-destval-dialog.component';

@Component({
  selector: 'app-destinatarios',
  templateUrl: './destinatarios.component.html',
  styleUrls: ['./destinatarios.component.scss']
})
export class DestinatariosComponent implements OnInit {
  cargandoDatos: boolean;
  destintarios: Destinatario[];
  destintariosBackup: Destinatario[];
  destintarioSeleccionado: Destinatario;
  faq: any;
  visiblePath: string;
  maxPathLength: number = 100;
  puedeCrearOEliminar: boolean;
  mostrarError: boolean;
  eliminarSeleccionado: boolean;
  habilitarBotonEliminar: boolean
  habilitarBotones: boolean;
  selectedFile: any = null;
  formData: any = null;
  // Indica el modo de edicion ; si es OFF entonces el panel derecho queda sin informacion
  editingMode: EditingMode;
  displayedColumns = ['id', 'codigo', 'titulo', 'descripcion', 'targetType', 'target', 'fechaActualizacion', 'usuarioAutualizador'];
  dataSource!: MatTableDataSource<Destinatario>;
  selection: any;
  initialSelection: any;
  allowMultiSelect: boolean;
  tipoFiltrado: string = "";
  tiposDestinatarios: string[];
  filtroCodigo: string = '';
  filtroNombre: string = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  constructor(private destinatariosService: DestinatariosService, private route: ActivatedRoute, private router: Router, private authService: AuthService, public dialog: MatDialog) {
    this.editingMode = EditingMode.Off;
    this.puedeCrearOEliminar = false;
    this.eliminarSeleccionado = false;
    this.habilitarBotones = false;
    this.initialSelection = [];
    this.allowMultiSelect = false;
    this.destintariosBackup = [];
    this.habilitarBotonEliminar = false;
    this.selection = new SelectionModel<Destinatario>(this.allowMultiSelect, this.initialSelection);
  }



  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    for (let role of this.authService.getUser().roles) {
      if (role == Role.Admin || role == Role.MenuAdministrator) {
        this.puedeCrearOEliminar = true;
        break;
      }
    }
    this.loadDestinatarios();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  seleccionarDestinatario(element) {
    this.selection.toggle(element);
    this.habilitarBotones = false;
    let esNuevoMenu = false;
    this.habilitarBotonEliminar = false;
    if (!this.destintarioSeleccionado) {
      esNuevoMenu = true;
      this.destintarioSeleccionado = element;
    } else if (element && this.destintarioSeleccionado) {
      if (element.id != this.destintarioSeleccionado.id) {
        this.destintarioSeleccionado = element;
        esNuevoMenu = true;
      } else {
        this.destintarioSeleccionado = undefined;
      }
    }

    if (esNuevoMenu) {
      if (this.destintarioSeleccionado && this.destintarioSeleccionado.id) {
        this.habilitarBotones = true;
        if (!this.destintarioSeleccionado.habilitado) {
          this.habilitarBotonEliminar = true;
        }
      }
    }
  }
  salirAdministrador() {
    this.destinatariosService.salirAdministrador();
    this.router.navigate(["/login"]);
  }


  getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    let hour = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return day + '/' + month + '/' + year + " " + hour + ":" + minutes + ":" + seconds;
  }
  loadDestinatarios() {
    this.destintarios = [];
    this.destintariosBackup = [];
    this.cargandoDatos = true;
    this.destinatariosService.loadDestinatariosMenu(false).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let destinatario = new Destinatario(
              m.id,
              m.codigo,
              m.descripcion,
              m.titulo,
              m.targetType,
              m.target,
              this.getFormattedDate(new Date(m.fechaCreacion)),
              this.getFormattedDate(new Date(m.fechaActualizacion)),
              m.usuarioAutualizador,
              m.habilitado
            );
            this.destintarios.push(destinatario);
            this.destintariosBackup.push(destinatario);
          }

        }
        this.dataSource = new MatTableDataSource(this.destintarios);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.cargarDistintosTipos();
        this.cargandoDatos = false;
        this.eliminarSeleccionado = false;
        this.habilitarBotonEliminar = false;
        this.habilitarBotones = false;
        this.destintarioSeleccionado = undefined;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
      })
  }

  seleccionarParaEliminar() {
    this.eliminarSeleccionado = false;
    if (this.destintarioSeleccionado && this.destintarioSeleccionado.id) {
      const dialogRef = this.dialog.open(DeleteDestinatarioDialogComponent, {
        width: '400px',
        minHeight: '24vh',
        data: this.destintarioSeleccionado
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.loadDestinatarios();
        }
      });
    }

  }


  editarDestinatario() {
    if (this.destintarioSeleccionado && this.destintarioSeleccionado.id) {
      this.router.navigate(['/config/destinatario/'], { queryParams: { idDestinatario: this.destintarioSeleccionado.id } });
    }
  }

  nuevoDestinatario() {
    this.router.navigate(['/config/destinatario/']);
  }

  volver() {
    this.router.navigate(['/config/home']);
  }

  cancelDeleteOperation() {

    this.eliminarSeleccionado = false;
  }

  myOptions = [
    { label: 'Todos', value: 'todos' },
    { label: 'Email', value: 'email' },
    { label: 'Chat', value: 'chat' },
  ];

  onSelected(selectedValue: any) {
    //TO DO: Borrar console log
    console.log('seleccionado:', selectedValue);
  }

  cargarDistintosTipos() {
    this.tiposDestinatarios = ['Chat', DestinatarioTipo.Email];    // this.tiposDestinatarios = [...new Set(this.destintarios.map(d => d.targetType))];
  }

  aplicarFiltro(): void {
    const tipoFiltro = this.tipoFiltrado && "Chat"===this.tipoFiltrado? "Workgroup" : this.tipoFiltrado;
    this.destintarios = this.destintariosBackup.filter(x => this.tipoFiltrado == "" || x.targetType == tipoFiltro );
    if(this.filtroCodigo && this.filtroCodigo !="" && this.filtroCodigo.trim().length > 0) {
      this.destintarios = this.destintarios.filter(m => m.codigo?.toUpperCase().includes(this.filtroCodigo.trim().toUpperCase()));
    }

    if(this.filtroNombre && this.filtroNombre !="" && this.filtroNombre.trim().length > 0) {
      this.destintarios = this.destintarios.filter(m => m.titulo?.toUpperCase().includes( this.filtroNombre.trim().toUpperCase()));
    }
    this.dataSource = new MatTableDataSource(this.destintarios);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  cargarArchivo() {
    const dialogRef = this.dialog.open(ImportDestinatarioValidacionDialogComponent, {
      width: '600px',
      minHeight:'260px',
      //min-height: '400px',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDestinatarios();
    });
  }
  cancelarCargarArchivo() {
    this.selectedFile = null;
  }
}